import { Baby, Heart, Users } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setStoreCategory } from '../../Redux/store';
import CategoryCard from './CategoryCard';
import StoreItemRow from './StoreItemRow';

const ITEMS = [
  { name: 'At-Home Insemination Kit', price: '$39', tag: 'Bestseller', category: 'ip' },
  { name: 'Ovulation Test Strips (50)', price: '$18', tag: 'Refill', category: 'ip' },
  { name: 'Pregnancy Tests (10)', price: '$14', tag: '', category: 'ip' },
  { name: 'Ovulation + Pregnancy Test Bundle', price: '$28', tag: 'Save 15%', category: 'ip' },
  { name: 'Prenatal Vitamins', price: '$24', tag: '', category: 'ip' },
  { name: 'Direct Message Credits', price: '$5', tag: '', category: 'ip' },
  { name: 'Prenatal Vitamins', price: '$24', tag: '', category: 'expecting' },
  { name: 'Rainbow Baby Onesie', price: '$18', tag: '', category: 'expecting' },
  { name: 'Rainbow Swaddle', price: '$22', tag: '', category: 'expecting' },
  { name: 'Direct Message Credits', price: '$5', tag: '', category: 'donor' },
  { name: 'UV Protectant Syringes 20ct', price: '$22', tag: '', category: 'donor' },
  { name: 'Medical Sample Cups 20ct', price: '$16', tag: '', category: 'donor' },
  { name: 'Pregnancy Tests (10)', price: '$14', tag: '', category: 'donor' },
];

const CATEGORIES = [
  { id: 'ip', name: 'For Intended Parents', Icon: Heart, iconBg: 'bg-baby-pink', iconColor: 'text-pink-700' },
  { id: 'expecting', name: 'For New / Expecting Parents', Icon: Baby, iconBg: 'bg-baby-blue', iconColor: 'text-blue-700' },
  { id: 'donor', name: 'For Donors', Icon: Users, iconBg: 'bg-lilac', iconColor: 'text-purple-700' },
];

function StorePage() {
  const dispatch = useDispatch();
  const category = useSelector((s) => s.ui.storeCategory);

  if (category) {
    const filtered = ITEMS.filter((it) => it.category === category);
    return (
      <div className="h-full overflow-y-auto">
        <div className="flex flex-col gap-3 p-4">
          {filtered.map((it) => <StoreItemRow key={it.name} item={it} />)}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto">
      <div className="flex flex-col gap-3 p-4">
        {CATEGORIES.map((cat) => {
          const count = ITEMS.filter((it) => it.category === cat.id).length;
          return (
            <CategoryCard
              key={cat.id}
              category={cat}
              itemCount={count}
              onClick={() => dispatch(setStoreCategory(cat.id))}
            />
          );
        })}
      </div>
    </div>
  );
}

export default StorePage;
